/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/comment-2-text";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Comment2Text";
export { I as Comment2Text };
